import * as React from 'react';
import * as styles from './styles.css';

import { IconChevronLeft16 } from '@cian/ui-kit/icons';
import { UIText1 } from '@cian/ui-kit/typography';
import { IBackToPageProps } from './types';

export function BackToPageDesktop({ text, href, onClick }: IBackToPageProps) {
  return (
    <div className={styles['container']}>
      <a href={href} className={styles['link']} onClick={onClick}>
        <IconChevronLeft16 color="current_color" />{' '}
        <span>
          <UIText1 color="current_color">{text}</UIText1>
        </span>
      </a>
    </div>
  );
}
